<template>
  <div class="video-panel-wide">
    <div class="search-positioner">
      <search-widget noline animation />
    </div>
    <page-video-player :url="videoUrl" :artistLinks="timings" autoplay loop highlay />
    <div class="slide-overlay" :class="{collapsed: collapsed}">
      <div class="blurbside">
        <div style="display:inline-block">
          <follow-us animation />
        </div>
      </div>
      <div class="weare-illus">
        <div class="red-caps">#{{ $nippets.homeAnim.weareanimx }}</div>
        <h1 class="message">{{ $nippets.homeAnim.message }}</h1>
      </div>
      <div class="blurbside">
        <div class="side-message">
          <linkified-text><span v-html="$nippets.homeAnim.sideMessage"></span></linkified-text>
        </div>
      </div>
    </div>
    <plus-poker :collapsed="collapsed" v-on:click="handleUncollapse" />
  </div>
</template>

<script>
import PageVideoPlayer from '@/components/video/PageVideoPlayer.vue'
import SearchWidget from '@/components/widgets/SearchWidget.vue'
import PlusPoker from '@/components/buttons/PlusPoker.vue'
import FollowUs from '@/components/panels/FollowUs.vue'
import LinkifiedText from '@/components/widgets/LinkifiedText.vue'
import vt from '@/data/home-video-timing.js'

export default {
  components: {
    PageVideoPlayer,
    SearchWidget,
    PlusPoker,
    FollowUs,
    LinkifiedText
  },
  props:{
    videoUrl: String
  },
  mounted () {
    this.checkScroll()
    window.addEventListener('scroll', this.checkScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.checkScroll)
  },
  data () {
    return {
      collapsed: false,
      manual: false,
      timings: vt.timings
    }
  },
  methods: {
    handleUncollapse() {
      this.collapsed = false
    },
    checkScroll() {
      if(window.innerWidth < 641) {
        this.collapsed = false
        this.manual = true
        return
      }
      const bounding = this.$el.getBoundingClientRect();
      if(!this.manual) {
        
        let pos = bounding.top + (bounding.height / 3)
        if(pos < 0) {
          this.collapsed = true
          this.manual = true
          // or stop listening here
        }
      }
      else {
        if(bounding.bottom < 100) {
          this.collapsed = true
          this.manual = true
        }
      }
    }
  }

}
</script>

<style scoped>
.search-positioner{
  position:absolute;
  top:5%;
  left:45px;
  z-index:46;
}

.video-panel-wide{
  position:relative;
  overflow:hidden;
}

.slide-overlay{
  position:absolute;
  background-color:rgba(255,255,255,0.9);
  min-height:120px;
  box-sizing:border-box;
  padding:20px;
  display:flex;
  justify-content:space-around;
  align-items:center;
  z-index:40;
  bottom:0;
  left:0;
  width:100%;
  transition:all 0.5s ease;
}

.slide-overlay.collapsed{
  transform:translateY(100%);
}

.weare-illus{
  width:35%;
  text-align:center;
}

.blurbside{
  width:30%;
  text-align:center;
}

.side-message{
  display:inline-block;
  max-width:200px;
}

.message{
  max-width:300px;
  margin-left:auto;
  margin-right:auto;
  margin-top:12px;
}

.red-caps{
  text-transform:uppercase;
  color:#ce0e2d;
  font-size:25px;
  font-weight:500;
}

h1.message{
  font-size:16px;
  font-weight:normal;
  line-height:normal;
  margin-bottom:0;
}

@media screen and (max-width:640px) {
  .slide-overlay{
    position:relative;
    display:block;
    padding:3px 10px;
  }
  .blurbside{
    width:auto;
  }
  .weare-illus{
    width:auto;
  }
  .message{
    max-width:100%;
    margin:6px 0;
  }
  .side-message{
    display:block;
    max-width:100%;
  }
}
</style>